// extracted by mini-css-extract-plugin
export default {"root":"dhfs__root--b6e87"};